import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import '../styles/main.css';
import HistoryView from './HistoryView';
import Events from './Events';
import Booking from './Booking';
import Profile from './Profile';
import TopBar from './TopBar';
import Camera from './Camera';

const getView = page => {
  switch (page) {
    case 'RESULTS':
      return <HistoryView />;
    case 'BOOKING':
      return <Booking />;
    case 'PROFILE':
      return <Profile />;
    case 'CAMERA':
      return <Camera />;
    default:
      return <Events />;
  }
};

class Main extends Component {
  componentDidMount() {}

  render() {
    return (
      <div className="main">
        <TopBar />
        <div className="app">
          {this.props.page !== 'RESULTS' && getView(this.props.page)}
          <HistoryView hide={this.props.page !== 'RESULTS'} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  page: state.location.type,
  pathname: state.location.pathname,
}))(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js